import { formatConsultationDate, timeRemaining } from "@/utils/common_functions";
import React, { useState, useEffect } from "react";

interface DeadlineTimerProps {
    deadline_at: string;
}
export const DeadlineTimer: React.FC<DeadlineTimerProps> = (props) => {
    const { deadline_at } = props;
    const [remainingTime, setRemainingTime] = useState(timeRemaining(deadline_at));

    useEffect(() => {
        if (!deadline_at) return;

        const deadline = new Date(deadline_at).getTime();
        const deadlineISO = new Date(deadline).toISOString();

        const updateTime = () => {
            setRemainingTime(timeRemaining(deadlineISO));
        };

        updateTime();
        const now = Date.now();
        const diffMs = deadline - now;

        if (diffMs <= 0) return;

        let msNeedToNext = diffMs % 60000;
        if (msNeedToNext < 1000) msNeedToNext = 1000;

        const timer = setTimeout(updateTime, msNeedToNext);

        return () => clearTimeout(timer);
    }, [remainingTime]);

    return <React.Fragment>{remainingTime}</React.Fragment>
}